import {Injectable} from "@angular/core";
import {HttpClient} from "@angular/common/http";
import {Observable} from "rxjs";
import {map} from "rxjs/operators";
import {CommonTransformationService} from "./common-transformation.service";
import {QueryResult} from "@app/shared";
import {SelectItem} from "primeng/api";

@Injectable()
export class DirectoryService {

  constructor(private http: HttpClient, private transform: CommonTransformationService) {
  }

  getObs(): Observable<QueryResult> {
    const url = "/directory/obs?start=0&count=-1";
    return this.http.get<QueryResult>(url);
  }

  getObsInfo(name?: string): Observable<QueryResult> {
    let url = "/directory/obs/info?start=0&count=-1";
    if (name) {
      url += `&name=${name}`;
    }
    return this.http.get<QueryResult>(url);
  }

  getObsInfoAsDropdown(name?: string): Observable<SelectItem[]> {
    return this.getObsInfo(name).pipe(map(res => {
      return this.transform.convertToDropDown("name", res.list, "id", true);
    }));
  }

  getLocations(): Observable<QueryResult> {
    const url = "/directory/locations?start=0&count=-1";
    return this.http.get<QueryResult>(url);
  }

  getLocationsAsDropdown(): Observable<SelectItem[]> {
    return this.getLocations().pipe(map(res => {
      return this.transform.convertToDropDown("addrName", res.list, "id");
    }));
  }

  getResourceManagerSubordinates(fetchForMss?: boolean): Observable<QueryResult> {
    let url = `/directory/users/resource-manager-subordinates/self?`;
    if (fetchForMss) {
      url += `fetchForMss=${String(fetchForMss)}`;
    }
    return this.http.get<QueryResult>(url);
  }

  getResourceManagerSubordinatesAsDropdown(): Observable<SelectItem[]> {
    return this.getResourceManagerSubordinates().pipe(map(res => {
      return this.transform.convertToDropDown("fullName", res.list, null);
    }));
  }
}
